import { Fornecedor, getFornecedorDefault } from "src/app/interface/fornecedor";

export interface ProcessoCadastroRevisaoFornecedor {
    fornecedor: Fornecedor;
    CSTATUS_PROCESSO: string;
    CCODIGOLOJA: string;
    COBSERVACAO: string;
    NPROCESSO: number;

}

export const getProcessoCadastroRevisaoFornecedorDefault = (): ProcessoCadastroRevisaoFornecedor => {
  return {
    fornecedor: getFornecedorDefault(),
    CSTATUS_PROCESSO: '',
    CCODIGOLOJA: '',
    COBSERVACAO: ' ',
    NPROCESSO: 0,
  };
};
